import React from 'react';
import { useT } from '../../i18n/LanguageContext';
import './PressMarquee.css';

const ITEMS = [
  'BILLBOARD',
  'ROLLING STONE',
  'VIBE',
  'REMEZCLA',
  'TELEMUNDO',
  'REFORMA',
  'NETFLIX · INGOBERNABLE',
  'UBISOFT · GHOST RECON',
  'VEVO',
  'HIGH TIMES · CANNABIS CUP',
  'BUDWEISER MADE IN AMERICA',
];

export default function PressMarquee() {
  const { t } = useT();

  return (
    <section className="press" aria-label={t('press.label')}>
      <div className="press__inner">
        <span className="press__label">
          <span className="press__label-star">★</span>
          {t('press.label')}
        </span>
        <div className="press__marquee">
          <div className="press__track">
            {[...ITEMS, ...ITEMS].map((item, i) => (
              <span key={i} className="press__item">{item}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
